module.exports = __webpack_public_path__ + "files/soft.94328d8afa4f57874438bad2bb739dcc.png";